// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "tableRow-3pDQA";
var _4 = "cellContent-1CRmX";
var _5 = "title-3rNAa";
var _6 = "slider-2h2tK";
var _7 = "tableRow_fullDescr-2yShM";
var _8 = "col-1T1gS";
var _9 = "groupTitle-1Ga49";
var _a = "headingCell-2BDFr";
export { _1 as "__esModule", _2 as "tablet", _3 as "tableRow", _4 as "cellContent", _5 as "title", _6 as "slider", _7 as "tableRow_fullDescr", _8 as "col", _9 as "groupTitle", _a as "headingCell" }
export default { "__esModule": _1, "tablet": _2, "tableRow": _3, "cellContent": _4, "title": _5, "slider": _6, "tableRow_fullDescr": _7, "col": _8, "groupTitle": _9, "headingCell": _a }
